<template>
  <div class="form-horizontal">
      <vip-form :user="user"></vip-form>
      <div class="form-group">
        <div class="col-sm-10 col-sm-offset-2">
          <button class="btn btn-primary" @click="submit">确定</button>
        </div>
      </div>
    </div>
</template>

<script>
import * as TYPES from '../store/types'
import VipForm from '@/components/forms/Vip'

export default {
  components: {
    VipForm
  },
  computed: {
    user() {
      return this.$store.state.users.editing
    }
  },
  methods: {
    submit() {
      this.$store
        .dispatch(TYPES.DO_CREATE_VIP, this.$store.state.users.editing)
        .then(res => {
          if (res.data.ok) {
            this.$router.push('/recharge/' + this.user.profile.phone)
          } else {
            this.$notify({
              type: 'danger',
              title: '操作失败',
              content: res.data.msg
            })
          }
        })
        .catch(res => {
          console.log(res)
          this.$notify({
            type: 'danger',
            title: '操作失败',
            content: res.data.msg
          })
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/CreateVip.vue